import ResourceModelBase from 'odd-resource_model'

const OPTIONS = {
  apiPath: '/api',
  apiVersion: 'v1',
  scope: 'web',
  resourceType: 'order_items',
  attributes: [
    'id',
    'price',
    'quantity',
    'created_at',
    'variant',
    'variant_id',
    'order',
    'adjustment_total',
    'promotion_total',
    'use_type'
  ],
  editableAttributes: ['quantity', 'variant_id']
}

export default class OrderItem extends ResourceModelBase {
  constructor(attributes = {}) {
    super(OPTIONS, attributes)
  }

  // extra methods or helpers here...

  displayPrice(
    options = {
      toLocaleString: true
    }
  ) {
    if (options.toLocaleString) {
      return (this.price / 100).toLocaleString()
    } else {
      return this.price / 100
    }
  }

  displaySubTotal() {
    return ((this.price * this.quantity + this.adjustment_total) / 100).toLocaleString()
  }
}
